import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateAutoText } from "../api/updateAutoText";

export const useUpdateAutoText = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateAutoText(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["autoText"] });
    },
  });
};

